import { Construction } from 'lucide-react';

interface Props {
  name: string;
  description?: string;
}

export function ComingSoonPanel({ name, description }: Props) {
  return (
    <div className="flex min-h-[280px] flex-col items-center justify-center gap-3 rounded-lg border border-dashed border-outline-variant bg-surface-variant/40 px-6 py-12 text-center">
      <Construction className="h-10 w-10 text-outline" />
      <div className="text-base font-medium text-neutral-700">{name} · 功能开发中</div>
      <p className="max-w-md text-sm leading-relaxed text-neutral-500">
        {description ??
          '该资产类型暂未开放,敬请期待。当前优先打磨「角色 / 场景」的多视图设定图生成与一致性体验。'}
      </p>
    </div>
  );
}
